import {Component, EventEmitter, forwardRef, input, Input, output, Output} from '@angular/core';
import {NG_VALUE_ACCESSOR, ReactiveFormsModule} from '@angular/forms';
import {NgStyle} from '@angular/common';

@Component({
  selector: 'app-primary-input',
  imports: [
    NgStyle,
    ReactiveFormsModule,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PrimaryInputComponent),
      multi: true
    }
  ],
  templateUrl: './primary-input.component.html',
  styleUrl: './primary-input.component.scss'
})
export class PrimaryInputComponent {

  image = input<string>();
  @Input() label: string = '';
  @Input() showLabel: boolean = false;
  @Input() type: string = 'text';
  @Input() placeholder: string = '';
  @Input() selectValue: string = '';
  @Input() readonly: boolean = false;
  @Input() maxlength: number | null = null;
  @Input() icon: string = '';
  @Input() iconBackgroundColor: string = '#567DD9';
  @Input() inputBackgroundColor: string = '#d2e0ff40';
  @Input() isRequired: boolean = false;
  @Output() valueChange = new EventEmitter<string>();
  @Output() selectValueChange = new EventEmitter<string>();

  value: string = '';
  isDisabled: boolean = false;
  showPassword: boolean = false;

  // ControlValueAccessor implementation
  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onViewEvent = output<void>()
  onView() {
    this.onViewEvent.emit();
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.onChange(this.value);
    this.onTouched();
    this.valueChange.emit(this.value);
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
    this.type = this.showPassword ? 'text' : 'password';
  }

  ngOnInit(): void {
    if (this.selectValue) {
      this.selectValueChange.emit(this.selectValue);
    }
  }
}
